import { getNewProfileMatches } from "../../../api/api";
import MatchProfilePage from "./MatchProfilePage";

const NewProfilesPage = () => (
  <MatchProfilePage
    title="New Profiles"
    fetchProfiles={getNewProfileMatches}
  />
);

export default NewProfilesPage;
